<!-- <div class="content" role="main">
    <span>{{ title }} app is running!</span>
 </div> -->
 <app-loader></app-loader>
 <router-outlet></router-outlet>